import { Component, input, Input, InputSignal } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormInput, FormInputType } from '../../models';
import { CPF_MASK, CPF_SIZE } from '../../constants/cpf-validator.constants';
import { CNPJ_MASK, CNPJ_SIZE } from '../../constants/cnpj-validator.constants';
import { CEP_MASK, CEP_SIZE } from '../../constants/cep-validator.constants';

@Component({
  selector: 'app-form-grid',
  templateUrl: './form-grid.component.html',
  styleUrls: ['./form-grid.component.scss'],
})
export class FormGridComponent {
  readonly CPF_SIZE = CPF_SIZE;
  readonly CPF_MASK = CPF_MASK;

  readonly CNPJ_SIZE = CNPJ_SIZE;
  readonly CNPJ_MASK = CNPJ_MASK;

  readonly CEP_MASK = CEP_MASK;
  readonly CEP_SIZE = CEP_SIZE;

  readonly formGroupRef: InputSignal<FormGroup> = input<FormGroup>();
  readonly inputs: InputSignal<FormInput[]> = input<FormInput[]>();
  readonly gridClass: InputSignal<string> = input<string>('row');

  FormInputType = FormInputType;
}
